"use client";

import { Button } from "@relume_io/relume-ui";
import { RxChevronRight } from "react-icons/rx";
import { Link } from "react-router-dom";
export function Layout1() {
  return (
    <section id="relume" className="px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container">
        <div className="grid grid-cols-1 gap-y-12 md:grid-cols-2 md:items-center md:gap-x-12 lg:gap-x-20">
          <div>
            <h1 className="rb-5 mb-5 text-5xl font-bold md:mb-6 md:text-7xl lg:text-8xl">
              Our Journey and Challenges
            </h1>
            <p className="md:text-md">
            Kiva Care was born from a heartbreaking experience. One night, our founder encountered a critically injured dog named Kiva. Alone and with limited resources, she searched tirelessly for a veterinarian, risking her own safety to save Kiva’s life. Unfortunately, due to the unavailability of NGOs and medical support, Kiva survived only two days.

That night, our founder made a promise—no other Kiva should suffer due to a lack of resources and medical care. Since then, we have been on a mission to rescue, treat, and protect street animals. However, running these operations is challenging, especially with limited donations and societal indifference. We often fund rescues from our own pockets to keep going.

Your support, in any form, can help us save more lives. Please come forward and be a part of this mission.
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-4 md:mt-8">
            <Link to="/donation">
              <Button style={{ color: "white", background: "#147754" }} title="Donate" variant="secondary">
                Donate
              </Button>
              </Link>
              <Link to="/volunteer">
              <Button
                title="Join"
                variant="link"
                size="link"
              >
                Join
              </Button>
              </Link>
              {<RxChevronRight />}
            </div>
          </div>
          <div>
            <img
              src="../media/kiva.jpeg"
              className="w-full object-cover"
              alt="Relume placeholder image"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
